import { render } from "./ClientesList.vue?vue&type=template&id=d4209496&scoped=true"
import script from "./ClientesList.vue?vue&type=script&lang=js"
export * from "./ClientesList.vue?vue&type=script&lang=js"

import "./ClientesList.vue?vue&type=style&index=0&id=d4209496&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4209496"]])

export default __exports__